import React from 'react';
import { Space } from 'antd';
import Container from '@/components/container';
import './index.less';

export default (props) => {
  const {
    container = {},
    title = '',
    extra = [],
    remarkList = [],
    description = '',
    size = 'middle',
    icon = '',
    ...otherProps
  } = props;

  let extraBtn = React.Children.toArray(extra);

  return (
    <div className={`TY__common-page-header ${size}`} {...otherProps}>
      <Container {...container} bg={false}>
        <div className="TY__common-page-header-wrap">
          {icon && icon}
          <div style={{ width: '100%' }}>
            <div className="TY__common-page-header--title">
              <div className="TY__common-page-header--title-text">{title}</div>
              <div className="TY__common-page-header--title-button">
                <Space size={8}>
                  {extraBtn.length > 0 && extraBtn.map((item, index) => <div key={index}>{item}</div>)}
                </Space>
              </div>
            </div>
            {description}
            {remarkList.length > 0 && (
              <div className="TY__common-page-header--remark">
                <Space size={16}>
                  {remarkList.map((item, index) => (
                    <span key={index} className="TY__common-page-header--remark-item">
                      {item.label}：{item.text}
                    </span>
                  ))}
                </Space>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};
